export const isBDay = function () {
  const today = new Date();
  const currentYear = today.getFullYear();

  const thisYearBday = new Date(currentYear, 9, 12).getTime();
  console.log(thisYearBday)

  const nextYearBday = new Date(currentYear + 1, 9, 12).getTime();

  const lastYearBday = new Date(currentYear - 1, 9, 12).getTime();

  const currentTime = today.getTime();

  if (currentTime >= thisYearBday && currentTime < new Date(currentYear, 9, 14).getTime()) {
    return "ON_TIME";
  }

  const distanceToThisYear = Math.abs(currentTime - thisYearBday);
  const distanceToNextYear = Math.abs(currentTime - nextYearBday);
  const distanceToLastYear = Math.abs(currentTime - lastYearBday);

  if (currentTime < thisYearBday) {
    return distanceToThisYear < distanceToLastYear ? "IS_EARLY" : "IS_LATE";
  } else {
    return distanceToNextYear < distanceToThisYear ? "IS_EARLY" : "IS_LATE";
  }
};
